import { render, staticRenderFns } from "./BgMusicMuteBtn.vue?vue&type=template&id=9810f33c&scoped=true&"
import script from "./BgMusicMuteBtn.vue?vue&type=script&lang=js&"
export * from "./BgMusicMuteBtn.vue?vue&type=script&lang=js&"
import style0 from "./BgMusicMuteBtn.vue?vue&type=style&index=0&id=9810f33c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9810f33c",
  null
  
)

export default component.exports